import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { ManagerKeyPeopleModalProps } from "./ManagerKeyPeopleModal.types";
import { AvatarImage } from "../../../common/AvatarImage";
import { VeriHeading } from "../../../common/VeriHeading";
import { sqlDateToFullYear } from "../../../../utils/dates";
import { ReadMore } from "../../../common/ReadMore";
import { VeriModal } from "../../../modals/VeriModal";

export const ManagerKeyPeopleModal: React.FC<ManagerKeyPeopleModalProps> = ({
  employees,
  ...rest
}) => {
  return (
    <VeriModal {...rest}>
      <VeriHeading mt="32px" textStyle="h5">
        Key People
      </VeriHeading>
      {employees.map((employee) => {
        return (
          <Box key={employee.id} mt="24px">
            <Flex alignItems="center">
              <AvatarImage image={employee.imgUrl || ""} mr={"16px"} />
              <Box>
                <VeriHeading
                  textStyle="bodyRegular"
                  fontWeight={"700"}
                  fontSize={"16px"}
                  mt={0}
                >
                  {employee.name}
                </VeriHeading>
                <Flex>
                  <Text textStyle="bodyRegular">{employee.role}</Text>
                  <Text textStyle="bodyRegular" color="text.grey">
                    &nbsp;&middot; {sqlDateToFullYear(employee.startDate || "")}{" "}
                    - Present
                  </Text>
                </Flex>
              </Box>
            </Flex>
            <Box textStyle="bodyRegular" lineHeight="24px" mt="16px">
              <ReadMore limit={200} text={employee.description || ""} />
            </Box>
          </Box>
        );
      })}
    </VeriModal>
  );
};
